<div class="how-to-apply" #howToApply data-section-id="how-to-apply-section" data-section-name="How To Apply">
  <app-container>
    <div class="how-to-apply__content">
      <div class="how-to-apply__header">
        <i class="icon-info"></i>
        <h3>¿Cómo solicitar tu Avance o Súper Avance?</h3>
      </div>

      <p class="how-to-apply__text">
        Con Unipay es fácil, rápido y 100% en línea:
      </p>

      <div class="how-to-apply__list">
        <div class="how-to-apply__item">
          <div class="how-to-apply__icon">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-ws-iconos01-prod.png" alt="WhatsApp">
          </div>
          <div>
            <p class="how-to-apply__text-item">
              <span class="how-to-apply__text--bold--title">WhatsApp</span>
              <span class="how-to-apply__text--bold--content">Escríbenos al +56 9 5812 3297 y sigue las instrucciones.</span>
            </p>
          </div>
        </div>

        <div class="how-to-apply__item">
          <div class="how-to-apply__icon">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-iconos02.png" alt="Teléfono">
          </div>
          <div>
            <p class="how-to-apply__text-item">
              <span class="how-to-apply__text--bold--title">Teléfono</span>
              <span class="how-to-apply__text--bold--content">Llama al 600 390 9000 y elige la opción correspondiente.</span>
            </p>
          </div>
        </div>

        <div class="how-to-apply__item">
          <div class="how-to-apply__icon">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-ws-iconos03.png" alt="Supermercados">
          </div>
          <div>
            <p class="how-to-apply__text-item">
              <span class="how-to-apply__text--bold--title">Cajas de los supermercados Unimarc y Super 10 a lo largo de chile</span>
              <span class="how-to-apply__text--bold--content"> Puedes simular tu avance en nuestro número de WhatsApp y pedirlo en efectivo en cualquier caja.</span>
            </p>
          </div>
        </div>
      </div>

      <p class="how-to-apply__text-note">
        Recuerda que la aprobación está sujeta a evaluación crediticia y a las políticas vigentes de Unipay.
      </p>
    </div>
  </app-container>
</div>
